module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.latestnews, {
    tag: "component"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a1aa57a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/latestnews/latestNews.vue
// module id = 619
// module chunks = 27